/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `Comment.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { Comment } from "./Comment";

import { User } from "./User";

export abstract class CommentModel {
    id: number;
    body: string | null;
    commentableId: number;
    commentableType: string;
    createdAt: Dayjs;
    updatedAt: Dayjs;
    userId: number;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        body: string | null,
        commentableId: number,
        commentableType: string,
        createdAt: Dayjs,
        updatedAt: Dayjs,
        userId: number,
        user: User | null | undefined
    ) {
        this.id = id;
        this.body = body;
        this.commentableId = commentableId;
        this.commentableType = commentableType;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): Comment {
        const newObject = new Comment(
            json["id"],
            json["body"],
            json["commentable_id"],
            json["commentable_type"],
            dayjs(json["created_at"]).tz(timezone),
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            body: this.body,
            commentable_id: this.commentableId,
            commentable_type: this.commentableType,
            created_at: this.createdAt,
            updated_at: this.updatedAt,
            user_id: this.userId,
            user_attributes: this.user?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): Comment {
        const clone = Object.create(this) as Comment;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
